/** Shared console state */
export const state = { me: null, onboarding: null, nav: null, merchantHasDist: false };

export let authProviders = null;

export function setAuthProviders(data) {
  authProviders = data;
}
